import React from 'react';
import Footer from './components/Footer';
import {Routes, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import Home from './components/Home';
import ProjectDetail from './components/ProjectDetail';
import './PortalTheme.css';

function App({ instance }) {
  const [userInfo, setUserInfo] = React.useState();

  React.useEffect(() => {
    async function getUserInfo() {
      try {
        const response = await fetch('/.auth/me');
        const payload = await response.json();
        const { clientPrincipal } = payload;
        var userData = {userDetails: clientPrincipal.userDetails}
        if (clientPrincipal.claims && clientPrincipal.claims[0]) {
          const filteredNames = clientPrincipal.claims.filter(item => item.typ === 'name');
          filteredNames.map(item => (
            userData.name = item.val
          ))
          const filteredEmails = clientPrincipal.claims.filter(item => item.typ === 'emails');
          filteredEmails.map(item => (
            userData.emails = item.val
          ))
        }
        setUserInfo(userData);
      } catch (error) {
        setUserInfo(undefined);
      }
    }
    getUserInfo();
  }, []);

  return (
    <MsalProvider instance={instance}>
      <div className="portal-shell">
      <Routes>
        <Route path="/" element={<Home userInfo={userInfo} />} />
        <Route path="/project/:id" element={<ProjectDetail userInfo={userInfo} />} />
      </Routes>
      <Footer />
      </div>
    </MsalProvider>
  );
}

export default App;
